import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { t } from 'i18next';

import { attributeStatusColorMap, attributeStatusLabelKey } from 'companySettings/constants';
import { AttributeStatus } from 'companySettings/enums';
import { IPartFinderFamily } from 'companySettings/types';
import { StatusCell } from 'core/elements';
import { AgGridFilterOption } from 'core/enums';

import { IdCell } from './cells';

const formatStatus = ({ value }: ValueFormatterParams) =>
  value ? t(attributeStatusLabelKey[value as AttributeStatus]) : '';

// Each column as wide as what it shows: the grid does not stretch them to its width.
export const getColumnDefs = (): ColDef<IPartFinderFamily>[] => [
  {
    colId: 'id',
    width: 80,
    headerName: t('headerId'),
    field: 'id',
    filter: 'agNumberColumnFilter',
    cellRenderer: IdCell,
  },
  {
    colId: 'name',
    width: 200,
    headerName: t('headerName'),
    field: 'name',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'categoryName',
    width: 180,
    headerName: t('headerCategories'),
    field: 'categoryName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'productTypeName',
    width: 180,
    headerName: t('headerProductType'),
    field: 'productTypeName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'partsCount',
    width: 90,
    headerName: t('headerParts'),
    field: 'partsCount',
    filter: 'agNumberColumnFilter',
    // A count is filtered as "at least".
    filterParams: { defaultOption: AgGridFilterOption.GREATER_THAN_OR_EQUAL },
  },
  {
    colId: 'status',
    width: 130,
    headerName: t('headerStatus'),
    field: 'status',
    filter: 'agSetColumnFilter',
    filterParams: { valueFormatter: formatStatus },
    valueFormatter: formatStatus,
    cellRenderer: StatusCell,
    cellRendererParams: {
      colorMap: attributeStatusColorMap,
      labelMap: Object.fromEntries(
        Object.entries(attributeStatusLabelKey).map(([status, labelKey]) => [status, t(labelKey)])
      ),
    },
  },
  {
    colId: 'versionNumber',
    width: 100,
    headerName: t('headerVersion'),
    field: 'versionNumber',
    valueFormatter: ({ value }: ValueFormatterParams) =>
      value ? t('labelVersionNumber', { number: value }) : '',
  },
];
